export const config = {
  apiKey: 'AIzaSyBdoy4YKI6GNkpMygh15CvgA9j7X57Jv-4',
  authDomain: 'robotmon-98370.firebaseapp.com',
  databaseURL: 'https://robotmon-98370.firebaseio.com',
  projectId: 'robotmon-98370',
  storageBucket: 'robotmon-98370.appspot.com',
  messagingSenderId: '640484500823',
};
